import api from '../utils/api';

export async function listLlmFamilies() {
  const { data } = await api.get('/admin/llm-families');
  return data;
}

export async function createLlmFamily(payload) {
  const { data } = await api.post('/admin/llm-families', payload);
  return data;
}

export async function updateLlmFamily(id, payload) {
  const { data } = await api.patch(`/admin/llm-families/${id}`, payload);
  return data;
}

export async function listLlmModelLines() {
  const { data } = await api.get('/admin/llm-model-lines');
  return data;
}

export async function createLlmModelLine(payload) {
  const { data } = await api.post('/admin/llm-model-lines', payload);
  return data;
}

export async function updateLlmModelLine(id, payload) {
  const { data } = await api.patch(`/admin/llm-model-lines/${id}`, payload);
  return data;
}

export async function listLlmEffortLevels() {
  const { data } = await api.get('/admin/llm-effort-levels');
  return data;
}

export async function listLlmEffortConfigs() {
  const { data } = await api.get('/admin/llm-effort-configs');
  return data;
}

export async function upsertLlmEffortConfig(payload) {
  const { data } = await api.put('/admin/llm-effort-configs', payload);
  return data;
}
